const layout2 = `<div class="bg-[#F5F5F4] py-5 md:py-16">
                <div class="container mx-auto px-[15px] max-w-[1240px]">
                    <div class="space-y-5 md:space-y-[64px]">
                        <div class="flex flex-col md:flex-row justify-between gap-3 md:gap-6">
                            <div class="xs:w-full md:w-1/2">
                                <h3 class="text-[24px] md:text-[36px] text-stone-800 font-medium leading-[32px] md:leading-[40px] mb-1 md:mb-5">
                                    About the{" "}
                                    <br class="xs:hidden md:inline-block" />{" "}
                                    Desh Travels
                                </h3>
                                <p class="text-sm md:text-base text-stone-800 font-normal">
                                    Bipul Enterprise is a traditional name in
                                    the road transport world of Bangladesh. When
                                    Bangladesh was emerging as a country after
                                    independence, Ramesh Chandra Ghosh engaged
                                    in passenger transport services in 1973 and
                                    started Shyamoli Paribahan from his district
                                    town Pabna.
                                    <br />
                                    <br />
                                    Starting with 1 bus, now Shyamli has one of
                                    the largest bus fleets in the country with
                                    around 500 AC/Non-AC luxury chair coach
                                    buses. Dolor augue curae montes eget
                                    sollicitudin diam praesent non mus in
                                    lobortis. Ligula magna himenaeos dictumst
                                    cubilia dolor morbi letius tempor in
                                    convallis.
                                </p>
                            </div>
                            <div class="xs:w-full md:w-1/2">
                                <img
                                    src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-8.png"
                                    width="100%"
                                    height="auto"
                                    alt="img"
                                />
                            </div>
                        </div>

                        <div class="flex flex-col md:flex-row justify-between xs:gap-8 md:gap-[56px]">
                            <div class="xs:w-full md:w-4/12">
                                <img
                                    src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/chairman.png"
                                    width="100%"
                                    height="auto"
                                    alt="img"
                                />
                            </div>

                            <div class="xs:w-full md:w-8/12">
                                <h6 class="text-xl text-red-600 font-semibold leading-[28px] mb-1 md:mb-2">
                                    Message from our chairman
                                </h6>
                                <h3 class="text-2xl md:text-4xl text-stone-800 font-medium mb-3 md:mb-5">
                                    John Doe
                                </h3>
                                <div class="bg-red-100 flex gap-4 p-4 rounded-xl box-shadow-2">
                                    <div class="min-w-[56px]">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/quote.svg"
                                            width="56"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <p class="text-base md:text-lg text-red-600 font-semibold italic">
                                        Starting with 1 bus, now Shyamli has one
                                        of the largest bus fleets in the country
                                        with around 500 AC/Non-AC luxury chair
                                        coach buses. Dolor augue curae montes
                                        eget sollicitudin diam praesent non mus
                                        in lobortis. Ligula magna himenaeos
                                        dictumst cubilia.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="grid grid-flow-dense xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
                                <div class="row-span-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-17.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-5.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-1.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-7.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div class="col-span-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-3.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-6.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <h3 class="text-[24px] md:text-[36px] text-center text-stone-800 font-medium leading-[32px] md:leading-[40px] mb-3 md:mb-5">
                                Easy steps to buy a ticket
                            </h3>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
                                <div class="bg-red-100 w-full h-[244px] px-4 py-8 rounded-[10px] md:rounded-xl">
                                    <h4 class="w-[64px] h-[64px] bg-red-600 text-white text-4xl font-medium leading-[40px] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        1
                                    </h4>
                                    <h6 class="text-red-600 text-center text-xl font-semibold leading-[28px] mb-1 line-clamp-1">
                                        Search Destination!
                                    </h6>
                                    <p class="text-stone-800 text-base text-center font-semibold leading-[24px] line-clamp-3">
                                        Go to bdtickets Website, Select your
                                        location, Select Bus Type, Select the
                                        date of your journey
                                    </p>
                                </div>
                                <div class="bg-red-600 w-full h-[244px] px-4 py-8 rounded-[10px] md:rounded-xl">
                                    <h4 class="w-[64px] h-[64px] bg-red-100 text-red-600 text-4xl font-medium leading-[40px] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        2
                                    </h4>
                                    <h6 class="text-white text-center text-xl font-semibold leading-[28px] mb-1 line-clamp-1">
                                        Search Destination!
                                    </h6>
                                    <p class="text-white text-base text-center font-semibold leading-[24px] line-clamp-3">
                                        Click the View Seats option, Select your
                                        seats, Provide all the information,
                                        Select the Next option
                                    </p>
                                </div>
                                <div class="bg-red-100 w-full h-[244px] px-4 py-8 rounded-[10px] md:rounded-xl">
                                    <h4 class="w-[64px] h-[64px] bg-red-600 text-white text-4xl font-medium leading-[40px] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        3
                                    </h4>
                                    <h6 class="text-red-600 text-center text-xl font-semibold leading-[28px] mb-1 line-clamp-1">
                                        Search Destination!
                                    </h6>
                                    <p class="text-stone-800 text-base text-center font-semibold leading-[24px] line-clamp-3">
                                        You can pay via VISA, AMEX, Master Card,
                                        Nagad and bKash and more, After making
                                        all the payment procedures, you will get
                                        your ticket.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h2 class="text-2xl md:text-4xl text-center text-[#292524] font-medium mb-4">
                                Our Seats
                            </h2>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
                                <div class="bg-white rounded-[10px] md:rounded-2xl overflow-hidden box-shadow-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-18.png"
                                        class="w-full !object-cover"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                    <div class="px-4 pt-3 pb-4">
                                        <h4 class="text-base text-stone-800 font-semibold leading-[24px] mb-1">
                                            Business Class
                                        </h4>
                                        <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                            Excepteur sint occaecat cupidatat
                                            non proident, sunt in culpa qui
                                            officia deserunt mollit anim id est
                                            laborum.
                                        </p>
                                    </div>
                                </div>
                                <div class="bg-white rounded-[10px] md:rounded-2xl overflow-hidden box-shadow-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-19.png"
                                        class="w-full !object-cover"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                    <div class="px-4 pt-3 pb-4">
                                        <h4 class="text-base text-stone-800 font-semibold leading-[24px] mb-1">
                                            Economy Class
                                        </h4>
                                        <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                            Excepteur sint occaecat cupidatat
                                            non proident, sunt in culpa qui
                                            officia deserunt mollit anim id est
                                            laborum.
                                        </p>
                                    </div>
                                </div>
                                <div class="bg-white rounded-[10px] md:rounded-2xl overflow-hidden box-shadow-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-20.png"
                                        class="w-full !object-cover"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />
                                    <div class="px-4 pt-3 pb-4">
                                        <h4 class="text-base text-stone-800 font-semibold leading-[24px] mb-1">
                                            Non-AC Seats
                                        </h4>
                                        <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                            Excepteur sint occaecat cupidatat
                                            non proident, sunt in culpa qui
                                            officia deserunt mollit anim id est
                                            laborum.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="!mb-5 md:!mb-[64px]">
                            <h3 class="text-[24px] md:text-[36px] text-center text-stone-800 font-medium leading-[32px] md:leading-[40px] mb-3 md:mb-5">
                                Available bus types
                            </h3>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
                                <div class="bg-white w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-red-100 flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_ac_XL_light.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-stone-800 text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        AC
                                    </h6>
                                    <p class="text-stone-800 text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                                <div class="bg-white w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-red-100 flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_non_ac_L_light.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-stone-800 text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        Non-AC
                                    </h6>
                                    <p class="text-stone-800 text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                                <div class="bg-white w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-red-100 flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-seat-side-view-outline-svgrepo-com 1.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-stone-800 text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        Sleepers
                                    </h6>
                                    <p class="text-stone-800 text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                                <div class="bg-white w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-red-100 flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-svgrepo-com 1.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-stone-800 text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        Double Deckers
                                    </h6>
                                    <p class="text-stone-800 text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-white">
                    <div class="container mx-auto px-[15px] max-w-[1240px] py-5 md:py-[64px]">
                        <div class="flex flex-col lg:flex-row items-center">
                            <p class="xs:w-full lg:w-1/3 text-[24px] md:text-[36px] xs:text-center lg:text-left text-stone-800 font-medium leading-[32px] md:leading-[40px] xs:mb-6 lg:mb-0">
                                We have some of{" "}
                                <br class="hidden lg:inline-block" /> the best
                                bus brands
                            </p>
                            <div class="xs:w-full max-md:mt-4 lg:w-2/3 flex flex-col sm:flex-row items-center gap-3 md:gap-6">
                                <div class="w-full flex flex-col justify-center items-center">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/volvo.svg"
                                        class="mb-3"
                                        width="64"
                                        height="auto"
                                        alt="icon"
                                    />
                                    <p class="text-base text-center text-stone-800 font-semibold leading-[24px] line-clamp-3">
                                        Hyundai it elit tellus, luctus nec
                                        ullamcorper mattis, pulvinar
                                    </p>
                                </div>
                                <div class="w-full flex flex-col justify-center items-center">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/scania.svg"
                                        class="mb-3"
                                        width="108"
                                        height="auto"
                                        alt="icon"
                                    />
                                    <p class="text-base text-center text-stone-800 font-semibold leading-[24px] line-clamp-3">
                                        Hyundai it elit tellus, luctus nec
                                        ullamcorper mattis, pulvinar
                                    </p>
                                </div>
                                <div class="w-full flex flex-col justify-center items-center">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/isuzu.svg"
                                        class="mb-3"
                                        width="128"
                                        height="auto"
                                        alt="icon"
                                    />
                                    <p class="text-base text-center text-stone-800 font-semibold leading-[24px] line-clamp-3">
                                        Hyundai it elit tellus, luctus nec
                                        ullamcorper mattis, pulvinar
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;
export default layout2;
